/**
 * Department invite links (docs/guardian/03 §1.3, 2026-10-21).
 *
 * The emailed link is /join?token=…. The token is read once, moved to
 * sessionStorage (this tab only, gone when it closes) and removed from the
 * address bar and history at once, so it never lingers in history or a
 * Referer. It survives the sign-in / sign-up detour and is cleared after the
 * accept call (success or a final refusal) and on sign-out.
 */
import { safeSessionStorage } from './safeStorage';

const KEY = 'guardianJoinToken';
// token_urlsafe(32) is 43 chars; the Backend accepts 16..128.
const TOKEN_RE = /^[A-Za-z0-9_-]{16,128}$/;

export function readJoinTokenFromUrl() {
  const url = new URL(window.location.href);
  const token = url.searchParams.get('token');
  if (!url.searchParams.has('token')) return getPendingJoinToken();
  url.searchParams.delete('token');
  window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
  if (token && TOKEN_RE.test(token)) {
    safeSessionStorage.set(KEY, token);
    return token;
  }
  return getPendingJoinToken();
}

export function getPendingJoinToken() {
  const token = safeSessionStorage.get(KEY);
  return token && TOKEN_RE.test(token) ? token : null;
}

export function clearPendingJoinToken() {
  safeSessionStorage.remove(KEY);
}
